import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 退款状态
 */
class RefundStateQuery extends UltMeta {
    TO_BE_CONFIRMED = new Meta(0, "待确认");

    PENDING_CONFIRMATION = new Meta(1, "确认中");

    COMPLETED = new Meta(2, "退款完成");

    REJECTED = new Meta(3, "已驳回");
}

export const REFUND_STATE_QUERY = new RefundStateQuery();

class RefundStateShow extends UltMeta {
    PENDING_CONFIRMATION = new Meta(1, "待确认");

    COMPLETED = new Meta(2, "退款完成");

    REJECTED = new Meta(3, "已驳回");
}

export const REFUND_STATE_PC = new RefundStateShow();

// 操作方
class RefundInitiator extends UltMeta {
    ADMIN = new Meta(1, "供应链端");

    CUSTOM = new Meta(2, "客户端");
}

export const REFUND_INITIATOR = new RefundInitiator();
